export default __webpack_public_path__ + "static/media/MoodLaugh.bc958b1c.png";